import React from 'react';
import { Navigate } from 'react-router-dom';
import AppHeader from '../components/ui/AppHeader';
import ExternalPortalsPreviewPanel from '../components/admin/ExternalPortalsPreviewPanel';
import { useAuth } from '../utils/AuthContext';
import { useCRM } from '../utils/CRMContext';
import { canPreviewPartnerPortals } from '../utils/userRoles';
import './ExternalPortalsPage.css';

const ExternalPortalsPage: React.FC = () => {
  const { user } = useAuth();
  const { crmUsers, supplierOrgs } = useCRM();
  const canPreview = canPreviewPartnerPortals(user?.role);

  if (!canPreview) {
    return <Navigate to="/project-hub" replace />;
  }

  const isAdmin = user?.role === 'admin';

  return (
    <div className="ext-portals-page">
      <AppHeader />
      <main className="ext-portals-main">
        <header className="ext-portals-header">
          <h1>External portals</h1>
          <p>
            Open a partner or restricted portal as staff preview. You are not signing in as that person —
            navigation uses the same preview links as Project Hub and vendor admin.
          </p>
        </header>
        <ExternalPortalsPreviewPanel
          crmUsers={crmUsers}
          supplierOrgs={supplierOrgs}
          showCpa={isAdmin}
        />
      </main>
    </div>
  );
};

export default ExternalPortalsPage;
